import { graphql } from "@/lib/gql/__generated__";

export const CreateContact = graphql(/* GraphQL */ `
	mutation CreateContact($input: ContactCreateInput!) {
		contactCreate(input: $input) {
			userErrors
			contact {
				id
				hotelID
				contactID
				title
				messages {
					message
					images {
						bucket
						key
						region
						mimeType
						fileName
					}
					relatedURLs
					senderType
					createdAt
				}
			}
		}
	}
`);
